import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BotService } from 'src/app/bots/bot.service';
import { find, pull } from 'lodash';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AdminService } from '../admin.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
  selector: 'app-admin-bot',
  templateUrl: './admin-bot.component.html',
  styleUrls: ['./admin-bot.component.css'],
})
export class AdminBotComponent implements OnInit {
  @ViewChild('tagInput') tagInputRef: ElementRef;
  tags: string[] = [];

  @Input() merchant_id: string;
  @Input() refresh: Boolean;
  allBotDetails: any;
  allBotsWebhookUrls: any[];
  allBotConfigurationDetails: any;
  botDetails: any;
  botId: any;
  activeBot: any;
  is_discoverable;
  is_searchable;
  image_upload = false;
  tagsInput = '';
  bot;
  countryList: any = [];
  stateList: any = [];
  cityList: any = [];

  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  dropdown_country_icon = false;
  dropdown_states_icon = false;

  countryForm: FormGroup;
  getCountriesCache = [];
  getStatesCache = {};
  getCitiesCache = {};

  file: any;
  uploadedImageSrc: string | ArrayBuffer;
  isImageUploaded: boolean;
  tags_error: string = '';
  backSpaceTriggertoRemove = false;
  seletedCountry = {};
  selectedState = {};
  selectedCity = {};

  constructor(
    private botService: BotService,
    private _formBuilder: FormBuilder,
    private adminService: AdminService,
    private _snackBar: MatSnackBar,

  ) { }

  ngOnInit(): void {
    this.countryForm = this._formBuilder.group({
      countries: this._formBuilder.array([this.createCountryFormGroup()])
    });
    this.getAllBotDetails();
    this.getAllCountrylist(0);
  }


  getCountriesPromise(): Promise<{ code: string; name: string }[]> {
    return new Promise((resolve, reject) => {
      if (this.getCountriesCache.length > 0) {
        resolve(this.getCountriesCache);
        return;
      }
      this.adminService.getCountry().subscribe(
        (res) => {
          this.getCountriesCache = res.body.data;
          resolve(res.body.data);
        },
        (err) => reject(err)
      );
    });
  }

  getStatesPromise(country_code: string): Promise<{ code: string; name: string }[]> {
    return new Promise((resolve, reject)=> {
      if (this.getStatesCache[country_code]?.length > 0) {
        resolve(this.getStatesCache[country_code]);
        return;
      }
      this.adminService.getSateWithCountry(country_code).subscribe(
        (res) => {
          this.getStatesCache[country_code] = res.body.data;
          resolve(res.body.data);
        }, (err) => reject(err)
      );
    });
  }


  getCitiesPromise(country_code: string, state_code: string): Promise<{ code: string; name: string }[]> {
    return new Promise((resolve, reject)=> {
      if (!this.getCitiesCache[country_code]) this.getCitiesCache[country_code] = {};
      if (!this.getCitiesCache[country_code][state_code]) this.getCitiesCache[country_code][state_code] = [];
      if (this.getCitiesCache[country_code][state_code]?.length > 0) {
        resolve(this.getCitiesCache[country_code][state_code]);
        return;
      }
      this.adminService.getCityWithCountryandState(country_code, state_code).subscribe(
        (res) => {
          this.getCitiesCache[country_code][state_code] = res.body.data;
          resolve(res.body.data);
        }, (err) => reject(err)
      );
    });
  }

  ngOnChanges() { }

  get form() { return this.countryForm.get('countries') as FormArray; }

  getAllBotDetails() {
    this.botService.getBotDetailsByAdmin(this.merchant_id).subscribe(
      (res) => {
        this.allBotDetails = res.body.data;
        if (this.allBotDetails.length > 0) {
          this.activeBot = this.allBotDetails[0];
          this.is_discoverable = this.activeBot.is_discoverable;
          this.is_searchable = this.activeBot.is_searchable;
          this.getCountryData(this.activeBot.bot_id);
          this.getBotLabels(this.activeBot.bot_id)
          this.getRegionsForBot()
        }
      });
  }
  getBotLabels(botId) {
    this.adminService.getLabels(botId).subscribe(
      (res) => {
        this.tags = res.data;
      }
    )
  }
  updateBotLabels() {
    const updatedTags = {
      data: this.tags
    }
    this.adminService.updateLabels(this.activeBot.bot_id, updatedTags).subscribe(
      (res) => { }
    );
  }

  focusTagInput(): void {
    if (this.tagInputRef) this.tagInputRef.nativeElement.focus();
  }

  onKeyUp(event: KeyboardEvent): void {
    const inputValue: string = this.tagsInput;
    let words = inputValue.split(/\s+/);
    this.tags_error = "";
    if (words.length >= 3) {
      this.tagInputRef.nativeElement.value = words[0] + ' ' + words[1]
      this.tags_error = "A tag can have only two words"
    }
    if (event.code === 'Backspace' && !inputValue) {
      if (this.backSpaceTriggertoRemove)
        this.removeTag();
      else this.backSpaceTriggertoRemove = true;
      return;
    } else {
      this.backSpaceTriggertoRemove = false;
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        this.addTag(inputValue);
        this.backSpaceTriggertoRemove = true;
      }
    }
  }

  fileUpload(event) {
    if (event.target.files && event.target.files.length) {
      this.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => (this.uploadedImageSrc = reader.result);

      reader.readAsDataURL(this.file);
      this.botService.updateProfilePhoto(this.botId, this.file).subscribe(
        (result) => { },
        (error) => {
          if (error.status === 200) {
            this.isImageUploaded = true;
          }
        }
      );
    }
  }

  addTag(tag: string): void {
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if (this.tags.includes(tag)) {
      this.tags_error = "Same tag cannot be entered twice"
    }
    if (this.tags.length >= 20) {
      this.tags_error = "Maximum of 20 tags are allowed"
    }
    if (tag.length > 0 && !find(this.tags, tag) && !this.tags.includes(tag) && this.tags.length < 20) {
      this.tags.push(tag);
    }
    this.tagsInput = '';
    this.updateBotLabels();

  }

  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this.tags, tag);
    } else {
      this.tags.splice(-1);
    }
    this.updateBotLabels();
  }

  getBotDetails(botId, index) {
    this.activeBot = this.allBotDetails.filter(x => x.bot_id === botId)[0];
    this.is_discoverable = this.activeBot.is_discoverable;
    this.is_searchable = this.activeBot.is_searchable;
    // this.getCountryData(this.activeBot.bot_id);
    this.tags = [];
    this.getBotLabels(this.activeBot.bot_id)
    this.getRegionsForBot();
  }

  createCountryFormGroup(): FormGroup {
    return new FormGroup({
      'country': new FormControl([]),
      'states': new FormControl([]),
      'city': new FormControl([])
    })
  }

  addcountryFormGroup() {
    const countries = this.countryForm.get('countries') as FormArray
    countries.push(this.createCountryFormGroup());
    this.getAllCountrylist(countries.length - 1);
    let index = countries.length - 1;
    this.seletedCountry[index] = null;
    this.selectedState[index] = [];
    this.selectedCity[index] = [];
  }

  removeOrClearcountry(i: number) {
    const countries = this.countryForm.get('countries') as FormArray
    if (countries.length > 1) {
      countries.removeAt(i)
      delete this.selectedState[i];
      delete this.seletedCountry[i];
      delete this.selectedCity[i];

    } else {
      countries.reset()
      delete this.selectedState[i];
      delete this.seletedCountry[i];
      delete this.selectedCity[i];
    }
  }

  onCityItemSelect(item: any, index) {
    var arrayControl = this.countryForm.get('countries') as FormArray;
    const cityControl = arrayControl.controls[index].get('city') as FormControl;
    // arrayControl.controls[index].patchValue(item);
    let value = cityControl.value;
    if(!value){
      value = item.name + ','
    }
    else if(item.checked){
      value = value + item.name + ',';
    } else {
      value = value.replace(`${item.name},`, "");
    }
    arrayControl.controls[index].patchValue({
      city: value
    })
    if (item.checked) {
      if (this.selectedCity.hasOwnProperty(index)) {
        this.selectedCity[index].push(item);
      } else {
        this.selectedCity[index] = [item];
      }
    } else {
      this.selectedCity[index] = this.selectedCity[index].filter(res => res.code != item.code);
    }
    this.cityList[index].map(e => { (e.name === item.name) ? e.checked = item.checked : null });
  }

  split(val) {
    return val.split(/,\s*/);
  }

  extractLast(term) {
    return this.split(term).pop();
  }

  extractFirst(term) {
    return this.split(term).shift();
  }

  async onStateItemSelect(item: any, index) {
    var arrayControl = this.countryForm.get('countries') as FormArray;
    const statesControl = arrayControl.controls[index].get('states') as FormControl;
    let value = statesControl.value;
    if(!value){
      value = item.name + ','
    }
    else if(item.checked){
      value = value + item.name + ',';
    } else {
      value = value.replace(`${item.name},`, "");
    }
    arrayControl.controls[index].patchValue({
      states: value
    })
    if (item.checked) {
      if (this.selectedState.hasOwnProperty(index)) {
        this.selectedState[index].push(item);
      } else {
        this.selectedState[index] = [item];
      }
    } else {
      this.selectedState[index] = this.selectedState[index].filter(res => res.code != item.code);

    }
    await this.getCityByCountryState(item, index);
    this.stateList[index].map(e => { (e.code == item.code) ? e.checked = item.checked : null });
  }

  async selectedData(item: any, index: number) {
    // console.log(item);
    const arrayControl = this.countryForm.get('countries') as FormArray;
    arrayControl.controls[index].patchValue({
      country: item.name
    });
    if (item.checked) {
      this.seletedCountry[index] = item;
    }
    await this.getStateByCountry(item.code, index);
    this.countryList[index].map(e => { (e.name === item.name) ? e.checked = item.checked : null });
  }
  saveLocation() {
    if(!this.activeBot.bot_id){
      return;
    }
    let reqBody = []
    for (const key in this.seletedCountry) {
      const countryValue = this.seletedCountry[key]
      if (countryValue) {
        let countryReqObject = {};
        countryReqObject['country_code'] = countryValue.code;
        countryReqObject['states'] = [];
        countryReqObject['cities'] = [];

        for (const stateObj of this.selectedState[key]) {
          countryReqObject['states'].push(stateObj.code);
          let cityObjList = {
            state_code: stateObj.code,
            cities: []
          };
          let cities = [];
          for (let obj of this.selectedCity[key]) {
            if (obj.parent === stateObj.code) {
              cities.push(obj.code);
            }
          }
          cityObjList.cities = cities;
          countryReqObject['cities'].push(cityObjList);
        }
        /*
        if (countryReqObject['states'].length === 0) {
          delete countryReqObject['states'];
        }
        if (countryReqObject['cities'].length === 0) {
          delete countryReqObject['cities'];
        }
        */
        reqBody.push(countryReqObject);

      }
    }
    if (reqBody.length > 0) {
      this.adminService.putRegionsForBot(this.activeBot.bot_id, { data: reqBody }).subscribe((res) => {

      },
        (err) => {
          if (err.status == 200) {
            this._snackBar.open("Availabilty regions added successfully", 'close', {
              duration: 3000,
              horizontalPosition: this.horizontalPosition,
            }
            )
          } else {
            let message = err.error.message ? err.error.message : "Something Went Wrong";
            this._snackBar.open(message, 'close', {
              duration: 3000,
              horizontalPosition: this.horizontalPosition,
            })
          }
        });
    }
  }

  async makeCountryObject(countryCode, index) {
    let countries = await this.getCountriesPromise();
    let obj = countries.find((dataObj) => dataObj.code == countryCode);
    this.selectedData(
      { name: obj.name, parent: null, code: obj.code, checked: true },
      index
    );
  }
  async makeStateObject(stateCode, countryCode, index){
    const stateData = await this.getStatesPromise(countryCode);
    let obj= stateData.find(res => res.code == stateCode);
    await this.onStateItemSelect({name: obj.name, code: obj.code, checked: true, parent: countryCode},index)

  }
  makeCityObject(city, stateCode, index){
    // this.adminService.getCityWithCountryandState(countryCode, stateCode).subscribe(
    //   (res)=>{
    //     const cityData
    //   }
    // )
    this.onCityItemSelect({code: city, name: city, checked: true, parent: stateCode}, index);
  }
  async getStateByCountry(country: any, ind: number) {
    this.stateList[ind] = await this.getStatesPromise(country);
    this.stateList[ind].map((element) => { element.checked = false; element.parent = country });
  }

  async getAllCountrylist(ind) {
    this.countryList[ind] = await this.getCountriesPromise();
    this.countryList[ind].map((element) => { element.checked = false; });
    
  }

  async getCityByCountryState(item, ind) {
    if (!item.checked) {
      this.cityList[ind] = this.cityList[ind].filter(res => res.parent != item.code);
      this.selectedCity[ind] = this.selectedCity[ind].filter(res => res.parent != item.code);
      // this.stateList[ind] = this.stateList[ind].map((element) => {
      //   if(element.code == item.code){
      //     element.checked = false;
      //   }
      // })
    } else {
      let cities = await this.getCitiesPromise(item.parent, item.code);
      const a = cities.map((str) => ({ name: str, code: str, parent: item.code, checked: false }));
      this.cityList[ind] = this.cityList[ind] || [];
      this.cityList[ind].push(...a);
    }
  }
  async builtRegions(data){
    let index = 0;
    for (const countryData of data) {
      let country_code = countryData.country_code;
      await this.makeCountryObject(country_code, index);
      for (let stateCode of countryData.states) {
        await this.makeStateObject(stateCode, country_code, index);
      }
      for (let cityObj of countryData.cities) {
        let state_code = cityObj.state_code;
        let cities = cityObj.cities;
        for (let cityName of cities) {
          this.makeCityObject(cityName, state_code, index);
        }
        // let cities = cityObj.
      }
      index++;
      this.addcountryFormGroup();
    }
  }
  getRegionsForBot(){
    this.countryForm = this._formBuilder.group({
      countries: this._formBuilder.array([this.createCountryFormGroup()])
    });
    this.countryList = [];
    this.stateList = [];
    this.cityList = [];  
    this.seletedCountry = {};
    this.selectedState = {};
    this.selectedCity = {};  
    this.adminService.getRegionsFoBots(this.activeBot.bot_id).subscribe(
      (res)=>{
        this.selectedCity[0]=[];
        this.selectedState[0]= [];
        this.seletedCountry[0] = null;
        this.builtRegions(res.body.data);
      }
    )
  }


  stateSel(Obj, val, e) {
    if (Obj.indexOf(val) == -1 && e.target.checked) Obj.push(val);
    else if (!e.target.checked) Obj.splice(Obj.indexOf(val), 1);
  }

  verifyBot() {
    let request = {
      is_discoverable: this.is_discoverable,
      is_searchable: this.is_searchable
    };
    this.adminService
      .updateBot(this.activeBot.bot_id, request)
      .subscribe(
        (response) => {
        },
        (error) => {
          if (error.status == 200) {
          }
        }
      );
  }

  getCountryData(botId) {
    this.botService.getCountry(botId).subscribe(x => {
      console.log(x);
    });
  }

}
